import React from 'react'
import PkgItineraryBar from '@pcln/pkg-itinerary-bar'
import { Box, Button, Flex, Text } from 'pcln-design-system'
import styled from 'styled-components'
import { buildPackageSearchHeaderProps } from './helpers'
import { Tune } from 'pcln-icons'

const Wrapper = styled(Box)`
  position: sticky;
  top: 0;
  z-index: 10;
`

export function PackageListingsSearchHeader({
  searchRequest,
  bundleComponents,
  handleFiltersClick,
  shouldAllowInternationalLapInfants = false,
}) {
  const packageProps = buildPackageSearchHeaderProps({ searchRequest, bundleComponents })

  return (
    <Wrapper>
      <PkgItineraryBar
        {...packageProps}
        shouldAllowInternationalLapInfants={shouldAllowInternationalLapInfants}
        filtersComponent={
          <Button onClick={handleFiltersClick} borderRadius='md' p={1} mx={1} aria-label='View Filters'>
            <Flex flexDirection='column' justifyContent={'center'} alignItems={'center'}>
              <Tune />
              <Text fontSize='0' mt='1'>
                Filters
              </Text>
            </Flex>
          </Button>
        }
      />
    </Wrapper>
  )
}
